import ApiClient from '../apiClient';

// ============ Dashboard Types ============

export interface DashboardStats {
  active_creators?: number;
  active_partners?: number;
  cpl_revenue?: number;
  revshare_revenue?: number;
  new_partners?: number;
  new_creators?: number;
}

// ============ Dashboard API ============

export const dashboardApi = {
  /**
   * Получить статистику дашборда
   */
  getStats: async (): Promise<DashboardStats> => {
    const response = await ApiClient.get('/staff/dashboard');
    return response.data;
  },
};

export default dashboardApi;
